module.exports = __webpack_public_path__ + "static/media/chess.c79dc011.jpg";